import * as S from './select-field.styles'

type SelectFieldProps = {
  children: React.ReactNode
  testID?: string
}

function SelectField(props: SelectFieldProps) {
  const { children, testID } = props

  return (
    <S.Field collapsable={false} testID={testID}>
      {children}
    </S.Field>
  )
}

export { SelectField }
